import { Box, Flex, Text } from '@mantine/core';
import { ASSETS_BUCKET_URL } from '@/config';

type CardHeaderProps = {
  title: string | React.ReactNode;
  onClose: () => void;
  description?: string | React.ReactNode;
  pb?: string | number;
  imgUrl?: string;
  divider?: boolean;
  showCloseIcon?: boolean;
  className?: string;
};

export const CardHeader = ({
  title,
  description,
  imgUrl,
  onClose,
  pb = 'sm',
  divider = true,
  showCloseIcon = true,
  className = '',
}: CardHeaderProps) => (
  <Flex
    justify="space-between"
    style={{
      borderBottom: !divider ? ' ' : 'var(--border)',
    }}
    pb={pb}
    gap={{
      // base: 'sm',
      sm: '0',
    }}
  >
    <Flex>
      <div
        className="header-img"
        style={{
          marginRight: imgUrl ? '6px' : 0,
        }}
      >
        {imgUrl && <img src={imgUrl} alt="" className={className} />}
      </div>
      <div>
        <Text
          fz={{
            base: 'lg',
            sm: 'xl',
          }}
          fw={600}
          c="dark"
          lh={1.2}
        >
          {title}
        </Text>
        {description && (
          <Text
            c="gray"
            fz={{
              base: 'sm',
              sm: 'md',
            }}
          >
            {description}
          </Text>
        )}
      </div>
    </Flex>
    {showCloseIcon && (
      <Box
        mt={{
          base: 'calc(-2px)',
          sm: 'calc(-8px)',
        }}
        className="pointer"
      >
        <img
          src={`${ASSETS_BUCKET_URL}/svg/Cancel.svg`}
          alt="Cancel"
          loading="lazy"
          onClick={onClose}
          className="icon-s3-new"
        />
      </Box>
    )}
  </Flex>
);
